import * as React from "react";
import { IAppointmentConfirmationProps } from "../Types";
import { renderAppointmentsList, renderConfirmationButtons, cantCheckinBecauseOfFutureAppointmentsMessage } from "../SubComponents";
import TimeDateUtilities from "../../../constants/TimeAndDate";
import { TypeOfFinalTransaction } from "../../../dtos/KioskDtos.dtos";

export const FutureOnlyAppointmentScenario = (props: IAppointmentConfirmationProps) => (
    <div>
        {renderAppointmentsList(props.appointments.futureAppointments, false, props)}
        {cantCheckinBecauseOfFutureAppointmentsMessage(
            props.textString, props.appointments.futureAppointments.length > 1,
            TimeDateUtilities.getTimeStringByLanguage(
                props.appointments.futureAppointments[0].scheduledDateTime,
                props.lang,
                -props.timeBeforeToCheckIn,
                'minutes')
        )}
        {renderConfirmationButtons(false, props, props.isLoadingSpinnerActive, TypeOfFinalTransaction.PatientInformedOfFutureOnlyAppointments)}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/Scenarios/FutureOnlyAppointmentScenario.tsx